<template>
	<div>
		<input type="file" ref="imageLoader" v-show="false" @change="convertImageToBase64"  accept="image/*">
		<div class='info-page'>
			<div class='cell-huge'>
				<img src="https://a.id-photo-verify.com/ali_h5_a1/cdn/baidu_pic/baidu_specs_pic_six/usual.png" mode="aspectFit"
				 id='fake-icon' />
				<img src="../assets/to_tutorial.png" mode="aspectFit" id='to-tutorial' @click="toTutorial" />
				<div class='spec-name'>{{name}}</div>
			</div>
			<div class='cell-strange' v-if='ele'>
				<div class='judge-container' v-if='ele'>
					<img src="../assets/yes.png" mode="aspectFit" class='judge-icon' /><span>支持保存电子照</span>
				</div>
				<div class='judge-container' v-else>
					<img src="../assets/no.png" mode="aspectFit" class='judge-icon' /><span>不支持保存电子照</span>
				</div>
				<div class='judge-container' v-if='print'>
					<img src="../assets/yes.png" mode="aspectFit" class='judge-icon' /><span>支持打印纸质照</span>
				</div>
				<div class='judge-container' v-else>
					<img src="../assets/no.png" mode="aspectFit" class='judge-icon' /><span>不支持打印纸质照</span>
				</div>
			</div>
			<div class="cell">
				<div class="cell-title">冲印尺寸
				</div>
				<div class="cell-content">{{pagesize}}
				</div>
			</div>
			<div class="cell">
				<div class="cell-title">像素尺寸
				</div>
				<div class="cell-content"> {{px}}
				</div>
			</div>
			<div class="cell">
				<div class="cell-title">分辨率
				</div>
				<div class="cell-content">{{ppi}}
				</div>
			</div>
			<div class="cell">
				<div class="cell-title">文件大小
				</div>
				<div class="cell-content">{{weight}}
				</div>
			</div>
			<div class="cell">
				<div class="cell-title">颜色
				</div>
				<div class="circle-container">
					<div v-for="item in bgColor" :class="item.s_color=='ffffff'?'circle-white':'circle'" :style="{background:'#'+item.s_color}"></div>
				</div>
			</div>
			<div class="cell cell-down">
				<div class="cell-title">其他
				</div>
				<div class="cell-content">无要求
				</div>
			</div>

		</div>
		<div class='button-container'>
			<div id='button' @click="processPhoto">
			  <img src="../assets/tutorial_btn_photo.png" id='make-icon'/><span>去拍证件照</span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import notify from "@/components/notify";
import {makeIdPhoto,specBySpecId,canPrint} from "@/data/api";
import {config} from "@/config/config";
import {toBase64} from "@/utils/utils";
import {choosePhoto} from "@/utils/alipay";

export default {
	data() {
		return {
			isMakingPhoto: false,
			name:'',
			spec_id:'',
			px:'',
			pagesize:'', 
			ppi:'',
			weight:'',
			bgColor:'',
			ele:'',
			print:''
		};
	},
	computed: {
	  ...mapState(["specInfo", "openId"])
	},
	created() {
		ap.setNavigationBar({
			title: "规格详情"
		});
		this.$ba.trackPageview('spec');
		this.getSpecInfo();
		this.canIPrint();
	},
	methods: {
		...mapMutations([
		  "RECORD_ORDERINFO",
		  "RECORD_PROCESSED_PHOTO",
		  "RECORD_SELECTED_BG",
			"RECORD_PROCESSED_PHOTO_NO_FAIR"
		]),
		getSpecInfo() {
			specBySpecId(this.specInfo.specId).then((res) => {
				let d = res.data.result;
				console.log(d);
				let pagesize
				if (d.height_mm && d.width_mm) {
					pagesize = d.width_mm + 'mm*' + d.height_mm + 'mm'
				}
				let weight
				if (d.file_size_max && d.file_size_min) {
					weight = ((d.file_size_min) / 1024) + '~' + ((d.file_size_max) / 1024) + 'KB'
				} else if (d.file_size_max) {
					weight = '不大于' + ((d.file_size_max) / 1024) + 'KB'
				} else if (d.file_size_min) {
					weight = '不小于' + ((d.file_size_min) / 1024) + 'KB'
				} else {
					weight = "无要求"
				}
				let bg_arr = JSON.parse(d.background_color); // 返回的背景色数组
				let bg_arr_list = [] // 返回的背景色变化后的值 
				for (let i = 0; i < bg_arr.length; i++) {
					let bg_color = {
						s_color: '',
					}
					// bg_color.r = parseInt(parseInt(bg_arr[i].start_color/256)/256);
					bg_color.s_color = bg_arr[i].start_color.toString(16);
					// bg_color.g = parseInt(bg_arr[i].start_color/256)%256;
					// bg_color.b=bg_arr[i].start_color%256;
					bg_arr_list.push(bg_color);
				}
				let ppi = d.ppi ? d.ppi : '无要求';


				this.name = d.name;
				this.spec_id = d.spec_id;
				this.px = d.width_px + 'px*' + d.height_px + 'px';
				this.pagesize = pagesize;
				this.ppi = ppi;
				this.weight = weight;
				this.bgColor = bg_arr_list;
			})
		},
		canIPrint(){
			canPrint(this.specInfo.specId).then((res)=>{
				if(res.data.code==200){
					this.ele=res.data.ele;
					this.print=res.data.print
				}
			})
		},
		toTutorial(){
			this.$router.push({
				name: "tutorial"
			});
		},
		convertImageToBase64(e) {
		  let file = e.target.files[0];
		  toBase64(file, res => {
		    
		    this.makePhoto(
		      res.base64_remove_head,
		      this.specInfo.specId,
		      this.openId
		    );
		  });
		},
		processPhoto() {
		  if (window.AlipayJSBridge) {
		    choosePhoto()
		      .then(res => {
		        this.isMakingPhoto = true;

						
		        this.makePhoto(res, this.specInfo.specId, this.openId);
		      })
		      .catch(err => {
		        console.log(err);
		      });
		  } else {
		    this.clickInput();
		  }
		},
		clickInput() {
		  this.$refs.imageLoader.click();
		},
		makePhoto(image, specId, openId) {
			ap.showLoading({
			  content: '制作中'
			});
		  makeIdPhoto(image, specId, openId)
		    .then((res) => {
		 			console.log(res)
		      if (res.data.code === 200) {
		        //制作成功
		        const {
		          file_name,
		          file_name_print,
		          file_name_print_wm,
		          file_name_wm,
		          is_print,
		          order_id,
		          origin_pic_name, 
		          final_pic_name, 
		          print_pic_name,
		          serial_number,
							no_fair_name,
							no_fair_name_wm,
							no_fair_pic_name,
							no_fair_print,
							no_fair_print_name,
							no_fair_print_wm		
		        } = res.data.result;
		
		        const orderInfo = {
		          orderId: order_id,
		          serialNum: serial_number
		        };
		
		        const processedPhoto = {
		          watermarkPhotoSrc: file_name_wm.map(
		            name => `${config.getPhotoBaseUrl}${name}`
		          ),
		          watermarkPrintPhotoSrc: file_name_print_wm.map(
		            name => `${config.getPhotoBaseUrl}${name}`
		          ),
		          PrintPhotoSrc: file_name_print.map(
		            name => `${config.getPhotoBaseUrl}${name}`
		          ),
		          PhotoSrc: file_name.map(
		            name => `${config.getPhotoBaseUrl}${name}`
		          ),
		          hasPrintPhoto: is_print,
		          origin_pic_name:origin_pic_name, 
		          final_pic_name:final_pic_name, 
		          print_pic_name:print_pic_name
		        };
						const processedPhotoNoFair={
							PhotoSrc: no_fair_name.map(
							  name => `${config.getPhotoBaseUrl}${name}`
							),
							watermarkPhotoSrc: no_fair_name_wm.map(
		            name => `${config.getPhotoBaseUrl}${name}`
		          ),
							PrintPhotoSrc: no_fair_print.map(
							  name => `${config.getPhotoBaseUrl}${name}`
							),
							watermarkPrintPhotoSrc: no_fair_print_wm.map(
							  name => `${config.getPhotoBaseUrl}${name}`
							),
							hasPrintPhoto: is_print,
							origin_pic_name:origin_pic_name, 
							final_pic_name:no_fair_pic_name,
							print_pic_name:no_fair_print_name,
						};
		        this.RECORD_ORDERINFO(orderInfo);
		        this.RECORD_PROCESSED_PHOTO(processedPhoto);
						this.RECORD_PROCESSED_PHOTO_NO_FAIR(processedPhotoNoFair);
						
		        this.isDone = true;
		
		        this.$router.push({ name: "preview" });
		      } else if(res.data.code === 400) {
		        ap.confirm(
		          {
		            title: "是否重新制作？",
		            content: "该规格不存在！"
		          },
		          (res) => {
		            if (res.confirm) {
		              this.$router.push({ name: "search" });
		            } else {
		              this.$router.push({ name: "home" });
		            }
		          }
		        );
		      }else if(res.data.code === 504) {
		        ap.confirm(
		          {
		            title: "是否重新制作？",
		            content: "该图片不能制作该规格！"
		          },
		          (res) => {
		            if (res.confirm) {
		               this.processPhoto();
		            } else {
		              this.$router.push({ name: "home" });
		            }
		          }
		        );
		      }else if(res.data.code === 503){
		        ap.confirm(
		          {
		            title: "是否重新制作？",
		            content: "没有检测到人脸或者检测到多张人脸"
		          },
		          (res) => {
		            if (res.confirm) {
		              this.processPhoto();
		            } else {
		              this.$router.push({ name: "home" });
		            }
		          }
		        );
		      }else if(res.data.code === 505){
		        ap.confirm(
		          {
		            title: "是否重新制作？",
		            content: "未知错误，请检查您的网络连接，或联系我们"
		          },
		          (res) => {
		            if (res.confirm) {
		              this.processPhoto();
		            } else {
		              this.$router.push({ name: "home" });
		            }
		          }
		        );
		      }else{
		      	ap.confirm(
		          {
		            title: "是否重新制作？",
		            content: "未知错误，请检查您的网络连接，或联系我们"
		          },
		          (res) => {
		            if (res.confirm) {
		              this.processPhoto();
		            } else {
		              this.$router.push({ name: "home" });
		            }
		          }
		        );
		      }
		    })
		    .catch(err => {
		    	console.log(err)
		      ap.showToast({
		        content: "无法连接服务器"
		      });
		    })
		    .then(() => {
		      this.isMakingPhoto = false;
		      ap.hideLoading();
		    });
		}
	},
	
}
</script>

<style scoped>
	.info-page {
		padding: 2.6667vw;
	}

	.cell-huge {
		width: 94.667vw;
		height: 185px;
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: #fff;
		position: relative;
	}

	#to-tutorial {
		width: 36px;
		height: 95px;
		position: absolute;
		right: 0;
		top: 23px;
	}

	.spec-name {
		font-weight: bold;
		font-size: 17px;
		color: rgba(68, 128, 231, 1);
		text-align: center;
	}

	#fake-icon {
		width: 99.5px;
		height: 105px;
		margin-top: 25px;
		margin-bottom: 10px;
	}

	.cell-strange {
		width: 94.667vw;
		height: 35px;
		background-color: rgba(244, 244, 255, 1);
	}

	.circle {
		width: 13px;
		height: 13px;
		border-radius: 50%;
		box-sizing: content-box;
		border: 2px solid hsla(0, 0%, 100%, 0.3);
		display: inline-block;
		margin: 14.5px 6px;
	}

	.circle-white {
		width: 13px;
		height: 13px;
		border-radius: 50%;
		box-sizing: content-box;
		border: 2px solid hsla(0, 0%, 73%, 0.3);
		display: inline-block;
		margin: 14.5px 6px;
	}

	.circle-container {
		float: right;
	}

	.button-icon {
		width: 22.5px;
		height: 22.5px;
		margin-left: 35px;
		margin-right: 3px;
	}

	#button{
	  width:94.667vw;
	  height:45px;
	  background:rgba(68,128,231,1);
	  box-shadow:0px 5px 10px 0px rgba(68,128,231,0.25);
	  border-radius:22.5px;
	  line-height:45px;
	  color: white;
	  font-size: 16px;
	  display: flex;
	  align-items: center;
	  margin-left:2.6667vw;
	  margin-top: 2.1333vw;
	}
	#make-icon{
	  width: 19px;
	  height: 16px;
	  margin-left: 32vw;
	  margin-right: 13px; 
	}

	.judge-icon {
		width: 15px;
		height: 15px;
		margin-right: 5px;
		margin-left: 20px;
	}

	.judge-container {
		width: 50%;
		height: 35px;
		display: inline-flex;
		align-items: center;
		text-align: center;
	}
</style>
